import React, { useState } from "react";
import "./cashpay.css";

export default function CashPayLinkButton({
  amount,
  description,
  disabled,
  setSelectedPay,
  selectedPay,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  return (
    <div className="payment-container">
      <h3
        className="payment-title"
        style={{ textAlign: "left", marginBottom: 4 }}
      >
        Mode de paiement
      </h3>

      <span
        className="payment-status"
        style={{
          display: "block",
          marginBottom: 14,
          fontSize: 14,
          color: "#666",
          textAlign: "left",
        }}
      >
        (cliquez sur le mode de paiement ){" "}
        <span style={{ color: "red" }}>*</span>
      </span>

      {/* Option 1 : CashPay */}
       <div
       className={`payment-card ${selectedPay === "cashpay" ? "active" : ""}`}
      //  onClick={(e) => e.preventDefault()}
      //  style={{
      //    opacity: 0.6,
      //    cursor: "not-allowed",
      //  }}
       onClick={() => setSelectedPay("cashpay")}
     >
       <div className="payment-left">
         <input
           type="radio"
           name="paymentMode"
           checked={selectedPay === "cashpay"}
           onChange={() => setSelectedPay("cashpay")}
           onClick={(e) => e.stopPropagation()}
           
         />
     
         <div className="payment-texts">
           <div className="payment-name">
             <img
                src="/mixx.png"
                alt="CashPay"
                className="payment-logo2"
              />
              <img
                src="/moov.png"
                alt="CashPay"
                className="payment-logo2"
              />
              <img
                src="/visa.png"
                alt="CashPay"
                className="payment-logo2"
              />
             
           </div>
     
            {/* <span style={{ color: "red", fontSize: 13, fontWeight: 600 }}>
             indisponible pour le moment
           </span> */}
         </div>
       </div>
     </div>

      {/* Option 2 : Payer à la caisse */}
      <div
        className={`payment-card ${selectedPay === "caisse" ? "active" : ""}`}
        onClick={() => setSelectedPay("caisse")}
      >
        <div className="payment-left">
          <input
            type="radio"
            name="paymentMode"
            checked={selectedPay === "caisse"}
            onChange={() => setSelectedPay("caisse")}
            onClick={(e) => e.stopPropagation()}
          />

          <div className="payment-texts">
            <div className="payment-name">PAR COMPTE MARCHAND
              
            </div>
          </div>
        </div>
      </div>

      {error && <p className="error">{error}</p>}
    </div>
  );
}